import React from 'react';
import { PieChart, Pie, ResponsiveContainer, Cell, Legend, Tooltip } from 'recharts';
import { CHAIN_COLORS } from '../../constants/chain_colors';
import { stringToColour } from '../../utilities/generateColorFromString';
import { getNumberWithCommas } from '../../utilities/money';

const pieData = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];

const PieChartPaddingComponent = (props) => {
  const { chartData } = props;

  const renderLegend = () => {
    const customizedData =
      chartData &&
      chartData.sort(function (b, a) {
        return b.name.length - a.name.length;
      });


    const marginIndex = customizedData.length === 2 ? '0px 0px 0px 85%' : customizedData.length === 1 ? "0px 0px 0px 150%" : "0px 20px 0px 0px"
    return (
      <div className="custom-legends-items">
        {customizedData &&
          customizedData.map((entry, index) => (
            <span>
              <li
                key={`item-${index}`}
                className="recharts-legend-item legend-item-0"
                style={{ margin: marginIndex, width: 150, listStyleType: 'none', }}
              // style={{ margin: 'auto auto auto 90%', width: 150, listStyleType: 'none', }}

              >
                <svg
                  className="recharts-surface"
                  width="14"
                  height="14"
                  viewBox="0 0 32 32"
                  version="1.1"
                  style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
                >
                  <path
                    stroke="none"
                    fill={
                      CHAIN_COLORS[entry.chain.toLowerCase()]
                        ? CHAIN_COLORS[entry.chain.toLowerCase()]
                        : stringToColour(entry.chain.toLowerCase())
                    }
                    d="M0,4h32v24h-32z"
                    className="recharts-legend-icon"
                  ></path>
                </svg>
                <span className="recharts-legend-item-text" style={{ color: ' rgb(38, 171, 164)' }}>
                  {entry.name}
                </span>
              </li>
            </span>
          ))}
      </div>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <p className="label" style={{ backgroundColor: '#FFF', padding: '3px 5px' }}>
          {`${payload[0].payload.chain.toUpperCase()} $${getNumberWithCommas(
            payload[0].value
          )} : ${payload[0].name.replace(payload[0].payload.chain.toUpperCase(), '')}`}{' '}
        </p>
      );
    }
  };

  return (
    <ResponsiveContainer width="100%" height={310}>
      <PieChart>
        <Pie
          data={chartData || pieData}
          cx="50%"
          cy="45%"
          innerRadius="55%"
          outerRadius="75%"
          fill="#8884d8"
          paddingAngle={1}
          minAngle={1}
          dataKey="value"
          height={250}

        // label={renderCustomizedLabel}
        >
          {(chartData || []).map((entry, index) => {
            return (
              <Cell
                key={`cell-${index}`}
                fill={
                  CHAIN_COLORS[entry.chain.toLowerCase()]
                    ? CHAIN_COLORS[entry.chain.toLowerCase()]
                    : stringToColour(entry.chain.toLowerCase())
                }
                value={entry.value}
              />
            );
          })}
        </Pie>
        <Tooltip content={<CustomTooltip />} />
        <Legend content={renderLegend} align="left" />
      </PieChart>
    </ResponsiveContainer>
  );
};

export default PieChartPaddingComponent;
